import React, { Component } from 'react';
import swal from 'sweetalert2';
import BlockUi from 'react-block-ui';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import {
  BootstrapTable,
  TableHeaderColumn,
  InsertButton
} from 'react-bootstrap-table';

import {
  initializePodcasts,
  postRssFeed,
  deletePodcasts,
  validatePodcast,
  updatePodcastDataAfterFetch,
  resetRssFeed,
  postOpml,
  updatePodcastName,
  updatePodcastUrl
} from '../../../../redux/actions/app-actions';
import { firebase } from '../../../../firebase';
import Overlay from '../../../../components/ui/tooltip/Overlay';
import ValidationForm from './ValidationForm';
import ModalWrapper from '../../../../components/ModalWrapper';
import LoginForm from '../LoginForm';
import { formatBytes, validUrl } from '../../../../utils/utils';
import 'sweetalert2/src/sweetalert2.scss';
import logo from '../../../../images/inflo_logo.png';
import { fetchSubscribedPodcasts } from '../../../../apis/podcasts';

// in bytes
const maxSizeAllowed = 2097152;

const cellEditProp = {
  mode: 'click',
  blurToSave: true
};

const selectRowProp = {
  mode: 'checkbox'
};

const tdStyle = {
  whiteSpace: 'normal'
};

class ModalPodcast extends Component {
  constructor(props) {
    super(props);

    this.state = {
      blocking: false,
      loadingPodcast: false,
      showValidateInput: true,
      showPodcatsTable: false,
      showSignInModal: false,
      row: null,
      feedUrl: null
    };

    // the podcast the user is about to log in
    this.podcast = null;
  }

  cleanState = () => {
    this.setState({
      loadingPodcast: false,
      showValidateInput: true,
      showPodcatsTable: false
    });
  };

  cleanStateOnCancelSubmit = () => {
    this.setState({
      loadingPodcast: false
    });
  };

  closeModal = () => {
    if (firebase.auth.currentUser) {
      firebase.auth.currentUser.getIdToken().then((token) => {
        fetchSubscribedPodcasts(token).then((res) => {
          this.props.dispatch(updatePodcastDataAfterFetch(res));
          this.props.dispatch(resetRssFeed());
          this.setState({
            blocking: false
          });
          this.props.onHide();
        });
      });
    }
  };

  validatePodcasts = () => {
    if (firebase.auth.currentUser) {
      firebase.auth.currentUser.getIdToken().then((token) => {
        this.setState({
          showPodcatsTable: true,
          showValidateInput: false
        });

        this.props.unsubscribedPodcasts.forEach((item) => {
          this.props
            .dispatch(validatePodcast(item.feedUrl, token, item.uuid))
            .then(() => {
              const shouldExit = this.props.unsubscribedPodcasts.some(
                (item) => item.status === 'validate'
              );
              if (!shouldExit) {
                this.setState({ blocking: false });
              }
            });
        });
      });
    }
  };

  handleUploadSubmit = (file) => {
    this.setState({ blocking: true });

    if (firebase.auth.currentUser) {
      firebase.auth.currentUser.getIdToken().then(async (token) => {
        const formData = new FormData();
        formData.append('xmlFile', file);

        if (!(file.name.endsWith('xml') || file.name.endsWith('opml'))) {
          this.setState({ blocking: false });
          swal({
            imageUrl: logo,
            title: '<div class="titleModal">Format type.</div>',
            html: `<p class="contentModal">The file that you are trying to upload is over the maximum upload file size limit of ${size}.</p>`,
            showConfirmButton: false,
            showCloseButton: true,
            background: '#121C24',
            allowOutsideClick: false
          });
        } else if (file.size > maxSizeAllowed) {
          this.setState({ blocking: false });
          const size = formatBytes(maxSizeAllowed);
          swal({
            imageUrl: logo,
            title: '<div class="titleModal">Maximum size.</div>',
            html: '<p class="contentModal">Please enter a valid feed url.</p>',
            showConfirmButton: false,
            showCloseButton: true,
            background: '#121C24',
            allowOutsideClick: false
          });
        } else {
          const response = await this.props.dispatch(postOpml(formData, token));

          if (!response.error) {
            this.validatePodcasts();
          } else {
            this.setState({ blocking: false });
            swal({
              imageUrl: logo,
              title: '<div class="titleModal">Cannot process file</div>',
              html:
                '<p class="contentModal">Please provide a valid OPML file.</p>',
              showConfirmButton: false,
              showCloseButton: true,
              background: '#121C24',
              allowOutsideClick: false
            });
          }
        }
      });
    }
  };

  handleValidateSubmit = async (values) => {
    this.setState({ blocking: true });

    const urls = values.rssFeed.split('\n').filter((url) => url);

    await this.props.dispatch(initializePodcasts(urls));

    this.validatePodcasts();
  };

  notifyUserForInvalidPodcasts = () => {
    const invalidPodcasts = this.props.subscribedPodcasts.filter(
      (item) => item.id === null
    );
    const hasInvalidPodcasts = invalidPodcasts.length;

    if (hasInvalidPodcasts) {
      const message = invalidPodcasts.reduce((message, item) => {
        return `${message}<br />${item.feedUrl}`;
      }, '');
      swal({
        imageUrl: logo,
        title:
          '<div class="titleModal">Failed to subscribe to some RSS feeds.</div>',
        html: `<p class="contentModal">${message}</p>`,
        showConfirmButton: false,
        showCloseButton: true,
        background: '#121C24',
        allowOutsideClick: false
      });
    }
  };

  postPocasts = (podcasts) => {
    if (firebase.auth.currentUser) {
      firebase.auth.currentUser.getIdToken().then((token) => {
        podcasts.forEach((podcast) => {
          const { username, password, duplicates, ...values } = podcast;
          this.props
            .dispatch(
              postRssFeed(
                values,
                token,
                podcast.feedUrl,
                podcast.username,
                podcast.password
              )
            )
            .then(() => {
              if (podcasts.length === this.props.subscribedPodcasts.length) {
                this.notifyUserForInvalidPodcasts();
                this.closeModal();
                this.cleanState();
                this.sendDataToDashboard();
              }
            })
            .catch(() => {
              this.closeModal();
              this.cleanState();
              swal({
                imageUrl: logo,
                title: '<div class="titleModal">Post failed.</div>',
                html:
                  '<p class="contentModal">Could not upload rss feed at the moment.</p>',
                showConfirmButton: false,
                showCloseButton: true,
                background: '#121C24',
                allowOutsideClick: false
              });
            });
        });
      });
    }
  };

  handleSubmit = () => {
    this.setState({ blocking: true });

    const validPodcasts = this.props.unsubscribedPodcasts.filter(
      (item) => item.status !== 'error'
    );
    const invalidPodcasts = this.props.unsubscribedPodcasts.filter(
      (item) => item.status === 'error'
    );

    const podcasts = validPodcasts.map((item) => {
      const { status, message, uuid, ...podcast } = item;
      return podcast;
    });

    const hasValidPodcasts = validPodcasts.length;
    const hasInvalidPodcasts = invalidPodcasts.length;

    if (hasValidPodcasts && !hasInvalidPodcasts) {
      this.setState({ loadingPodcast: true });
      this.postPocasts(podcasts);
    }

    if (hasValidPodcasts && hasInvalidPodcasts) {
      swal({
        imageUrl: logo,
        title: '<div class="titleModal">Subscribe to podcasts.</div>',
        html: `<p class="contentModal">You are about to subscribe to ${podcasts.length} podcasts. The invalid podcasts will be skipped.<br/><br/>Do you want to continue?</p>`,
        showCloseButton: true,
        background: '#121C24',
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonText: 'Continue',
        confirmButtonColor: '#E31690'
      })
        .then((value) => {
          if (value) {
            this.setState({ loadingPodcast: true });
            this.postPocasts(podcasts);
          } else {
            this.cleanStateOnCancelSubmit();
          }
        })
        .catch(() => {
          this.cleanStateOnCancelSubmit();
          return;
        });
    }

    if (!hasValidPodcasts && hasInvalidPodcasts) {
      swal({
        imageUrl: logo,
        title: '<div class="titleModal">Subscribe to podcasts.</div>',
        html:
          '<p class="contentModal">You cannot subscribe to invalid podcasts.</p>',
        showConfirmButton: false,
        showCloseButton: true,
        background: '#121C24',
        allowOutsideClick: false
      })
        .then(() => {
          this.cleanStateOnCancelSubmit();
        })
        .catch(() => {
          this.cleanStateOnCancelSubmit();
          return;
        });
    }
  };

  sendDataToDashboard = () => {
    this.props.updateDashboard();
  };

  cellEdit = (row, cellName, cellValue) => {
    // the table data are updated remotely, update redux state
    row[cellName] = cellValue;

    if (cellName === 'name') {
      const values = { ...row };

      values.name = cellValue;
      this.props.dispatch(updatePodcastName(values));
    }

    if (cellName === 'feedUrl') {
      const values = { ...row };
      values.feedUrl = cellValue;

      this.setState({ blocking: true });

      if (firebase.auth.currentUser) {
        firebase.auth.currentUser.getIdToken().then((token) => {
          this.props
            .dispatch(validatePodcast(cellValue, token, row.uuid))
            .then(() => {
              this.setState({ blocking: false });
            });
        });
      }
    }
  };

  formatValidFeed = (cell, row) => {
    if (cell === 'success') {
      return <i className="fa fa-check" aria-hidden="true"></i>;
    }

    if (cell === 'warning') {
      return (
        <Overlay text={row.message}>
          <div>
            <i className="fa fa-exclamation-triangle" aria-hidden="true"></i>
            <span className="podcast-status">Warning</span>
          </div>
        </Overlay>
      );
    }

    if (cell === 'error') {
      return (
        <Overlay text={row.message}>
          <div>
            <i className="fa fa-times" aria-hidden="true"></i>
            <span className="podcast-status">Error</span>
          </div>
        </Overlay>
      );
    }

    return <div className="spinner-border text-secondary"></div>;
  };

  formatUrlFeedColumn = (cell, row) => {
    return (
      <div className="podcast-feed">
        <span>{cell}</span>
        {row.secure && (
          <Overlay text="Sign in">
            <i
              className="fa fa-user fa-2x"
              aria-hidden="true"
              onClick={(e) => this.showSignInForm(e, row)}
            ></i>
          </Overlay>
        )}
      </div>
    );
  };

  hideSignInModal = () => this.setState({ showSignInModal: false });

  showSignInModal = () => this.setState({ showSignInModal: true });

  showSignInForm = (e, row) => {
    e.stopPropagation();
    this.podcast = row;
    this.setState({ feedUrl: row.feedUrl });
    this.showSignInModal();
  };

  closeSignInModal = (e) => {
    e.preventDefault();
    this.hideSignInModal();
  };

  submitLogInForm = (e, username, password, rememberme) => {
    e.preventDefault();
    this.hideSignInModal();

    if (firebase.auth.currentUser) {
      this.setState({ blocking: true });

      firebase.auth.currentUser.getIdToken().then((token) => {
        this.props
          .dispatch(
            validatePodcast(
              this.podcast.feedUrl,
              token,
              this.podcast.uuid,
              username,
              password
            )
          )
          .then((payload) => {
            this.setState({ blocking: false });
            if (payload.error) {
              swal({
                imageUrl: logo,
                title: '<div class="titleModal">Log in failed.</div>',
                html:
                  '<p class="contentModal">Please make sure that valid data is provided.</p>',
                showConfirmButton: false,
                showCloseButton: true,
                background: '#121C24',
                allowOutsideClick: false
              });
            } else {
              const credentials = { username: username, password: password };
              if (rememberme) {
                sessionStorage.setItem(
                  this.state.feedUrl,
                  JSON.stringify(credentials)
                );
              }
              swal({
                imageUrl: logo,
                title: '<div class="titleModal">Successful log in.</div>',
                html: '<p class="contentModal"></p>',
                showConfirmButton: false,
                showCloseButton: true,
                background: '#121C24',
                allowOutsideClick: false
              });
            }
          });
      });
    }
  };

  deleteRow = (rowKeys) => {
    this.props.dispatch(deletePodcasts(rowKeys));
  };

  rowStyleFormat = (row) => {
    const highlight =
      this.state.row && row.duplicates.some((u) => u === this.state.row.uuid);

    return {
      backgroundColor: highlight ? '#FFFFE0' : ''
    };
  };

  render() {
    const options = {
      onRowMouseOver: (row) => this.setState({ row: row }),
      onMouseLeave: () => this.setState({ row: null }),
      onDeleteRow: this.deleteRow,
      onCellEdit: this.cellEdit,
      insertBtn: () => (
        <InsertButton
          btnText="Add more"
          btnContextual="btn-info"
          btnGlyphicon="glyphicon-plus"
          onClick={() => this.setState({ showValidateInput: true })}
        />
      )
    };

    return (
      <div>
        <Modal
          show={this.props.show}
          onHide={this.props.onHide}
          aria-labelledby="contained-modal-title"
          bsSize="large"
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title">
              Add podcasts to your account
            </Modal.Title>
          </Modal.Header>
          <BlockUi tag="div" blocking={this.state.blocking}>
            <Modal.Body>
              {this.state.loadingPodcast && (
                <div className="podcast-notification">
                  <span>
                    Processing {this.props.subscribedPodcasts.length + 1} out of{' '}
                    {
                      this.props.unsubscribedPodcasts.filter(
                        (item) => item.status !== 'error'
                      ).length
                    }{' '}
                    ....
                  </span>
                </div>
              )}
              {this.state.showValidateInput && (
                <ValidationForm
                  onSubmit={this.handleValidateSubmit}
                  onSubmitUpload={this.handleUploadSubmit}
                  showClose={this.state.showPodcatsTable}
                  onClose={() => this.setState({ showValidateInput: false })}
                />
              )}
              {this.state.showPodcatsTable && (
                <div className="podcast-form">
                  <h4>Subscribe podcasts</h4>
                  <BootstrapTable
                    data={this.props.unsubscribedPodcasts}
                    remote
                    striped
                    hover
                    insertRow
                    deleteRow
                    cellEdit={cellEditProp}
                    selectRow={selectRowProp}
                    options={options}
                    trStyle={this.rowStyleFormat}
                  >
                    <TableHeaderColumn
                      dataField="uuid"
                      isKey={true}
                      hidden={true}
                    >
                      ID
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="status"
                      width="12%"
                      tdStyle={tdStyle}
                      dataFormat={this.formatValidFeed}
                      editable={false}
                    >
                      Status
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="name"
                      width="20%"
                      editable={false}
                      tdStyle={tdStyle}
                    >
                      Name
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="feedUrl"
                      width="50%"
                      tdStyle={tdStyle}
                      dataFormat={this.formatUrlFeedColumn}
                    >
                      Url Feed
                    </TableHeaderColumn>
                  </BootstrapTable>
                  <div className="podcast-buttons">
                    <button
                      className="btn btn-tags"
                      onClick={this.handleSubmit}
                      disabled={!this.props.unsubscribedPodcasts.length}
                    >
                      Subscribe
                    </button>
                  </div>
                </div>
              )}
            </Modal.Body>
          </BlockUi>
        </Modal>
        <ModalWrapper
          title="Podcast authentication required"
          show={this.state.showSignInModal}
          onClose={this.closeSignInModal}
        >
          <LoginForm
            podcast={this.state.feedUrl}
            onCancel={this.closeSignInModal}
            onSubmit={this.submitLogInForm}
          />
        </ModalWrapper>
      </div>
    );
  }
}

const mapStateToProps = (store) => ({
  unsubscribedPodcasts: store.app.unsubscribedPodcasts,
  subscribedPodcasts: store.app.subscribedPodcasts
});

export default connect(mapStateToProps)(ModalPodcast);
